import React from 'react';

import { AuctionInformationTooltipContainer } from './AuctionInformationTooltipContainer';
import { AuctionReduceBetModalContainer } from './AuctionReduceBetModalContainer';
import { PublicationDateContainer } from './PublicationDateContainer';
import { VASListContainer } from './VASListContainer';
import { DoublesRankingPopupContainer } from '../DoublesRankingPopupContainer';
import { PromotionDescriptionContainer } from './PromotionDescriptionContainer';

export function VASContainer() {
  return (
    <>
      <PublicationDateContainer />
      <VASListContainer />
      <PromotionDescriptionContainer />
      <AuctionInformationTooltipContainer />
      <AuctionReduceBetModalContainer />
      <DoublesRankingPopupContainer />
    </>
  );
}
